import { atom } from 'jotai';

export const pageAtom = atom(0);

export const openAtom = atom({
    toolsExperience: false,
    productType: false,
    projectType: false,
    offeredGratification: false,
    forGratification: false,
    hardSkills: false,
    softSkills: false,
    requiredAreaOfExpertise: false,
    projectDeadline: false,
    offeredWorkingType: false,
    usedLanguages: false,
    bizOrTech: false,
    requiredAvailability: false,
    locations: false,
    projectName: false,
})

export const addProjectAtomGlobal = atom({
  show: {
    projectName: true,
    projectType: true,
    projectStatus: true,
    gratification: true,
  },
  toolsExperience: false,
  productType: false,
  offeredGratification: false,
  forGratification: false,
  hardSkills: false,
  softSkills: false,
  requiredAreaOfExpertise: false,
  projectDeadline: false,
  offeredWorkingType: false,
  usedLanguages: false,
  bizOrTech: false,
  requiredAvailability: false,
  locations: false,
}) 